export default __webpack_public_path__ + "add-square-button.png";